import React from 'react'
import { createRegisterableComponent } from '@news-mono/web-common'
import { SportsMasterclassPromoCard } from './SportsMasterclassPromoCard'

export const SportsMasterclassPromoCardRegistration =
    createRegisterableComponent('sports-masterclass-promo-card', () => (
        <SportsMasterclassPromoCard />
    ))
